module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-11 col-md-offset-1 col-xs-12\">\n      <div class=\"qBanks\">\n        <div class=\"mp-qbanks\">\n          <div class=\"title\">Practice Sets</div>\n          <mp-resource-groups [resourceType]=\"qBankResourceType\"></mp-resource-groups>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/qbanks/qbanks.html
// module id = Crn7
// module chunks = 3